import {Component} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {DataTableRoutes} from 'src/app/constants/datatableUrls';
import {
  DatatableActionButton,
  DatatableEvent,
  DatatableHandler,
  DatatableHandlerSettings,
  IconType,
} from '../../../components/datatables/datatable/datatable/datatable.component';
import {TenantService} from '../../../services/tenant.service';
import {ConfirmModalComponent} from '../../../components/modals/confirm-modal/confirm-modal.component';
import {UsersClient} from '../../../generated-client/generated-api-client';
import {SimpleModalService} from 'ngx-simple-modal';
import {ToastrService} from 'ngx-toastr';
import {ErrorProcessorService} from '../../../services/error-processor.service';
import {ConfirmReasonModalComponent} from "../../../components/modals/archive-confirm-modal/confirm-reason-modal.component";
import { AuthHelperService } from 'src/app/services/auth-helper.service';
import { PersistentDataService } from '../../../services/persistent-data.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.sass'],
})
export class UserListComponent {
  private _dtActionButtonsFn: (data: any) => DatatableActionButton[] = data => {
    const id = data['id'];
    const isArchived = data['isArchived'];

    const editUrl = `/users/${id}`;

    // const isAdminUser = data['roles'].includes('Admin');
    var yourRegex = /^Admin$/g ;
    const isAdminUser = yourRegex.test(data['roles']);
    const buttonState = !this.isUserAdministrator && isAdminUser;

    const editAction = new DatatableActionButton('edit', 'Felhasználó szerkesztése', 'edit', editUrl, IconType.Normal, buttonState);
    const passwordChangeAction = new DatatableActionButton('passwordChange', 'Jelszó módosítás', 'password', undefined, IconType.Normal, buttonState);
    const archiveAction = isArchived
      ? new DatatableActionButton('unArchive', 'Felhasználó aktiválása', 'unarchive', undefined, IconType.Danger, buttonState)
      : new DatatableActionButton('archive', 'Felhasználó archiválása', 'archive', undefined, IconType.Success, buttonState);

    return [editAction, passwordChangeAction, archiveAction];
  };

  dtHandler?: DatatableHandler;
  dtSettings: DatatableHandlerSettings = DatatableHandler.getDefaultSettings();
  dtDataSourceUrl: string = DataTableRoutes.UsersList;
  isUserAdministrator: boolean = false;

  constructor(
    private titleService: Title,
    private _tenantService: TenantService,
    private usersClient: UsersClient,
    private _modalService: SimpleModalService,
    private _toastr: ToastrService,
    private errorProcessorService: ErrorProcessorService,
    private authService: AuthHelperService,
    private _pDservice: PersistentDataService
  ) {
    this.titleService.setTitle('Felhasználók');
    this.isUserAdministrator = this.authService.hasRole('Admin');

    this.dtSettings.buttons = [
      {
        text: 'Új felhasználó',
        class: 'btn-primary text-white',
        url: '/users/new',
      },
    ];
    this.dtSettings.actions = this._dtActionButtonsFn;
    this.dtSettings.pageSize = _pDservice.usersPageSize;
    this.dtSettings.searchString = _pDservice.usersSearchString;

    this.dtSettings.additionalRequestData = () => {
      if (this.dtHandler?.pageSize != null)
        _pDservice.usersPageSize = this.dtHandler?.pageSize
      if (this.dtHandler?.searchString != null)
        _pDservice.usersSearchString = this.dtHandler?.searchString
      return {
        tenantId: this._tenantService.activeTenantId,
      };
    };

    this._tenantService.tenantId.subscribe(tenantId => {
      this.dtHandler?.refresh();
    });

    this.dtSettings.additionalColumns = [
      {
        targets: 3,
        orderable: false,
      },
      {
        targets: 5,
        orderable: false,
      },
    ];
  }

  onAction(event: DatatableEvent) {
    if (event.actionId === 'passwordChange') {
      this.passwordChange(event.data['id']);
    }
    if (event.actionId === 'archive') {
      this.archive(event.data['id']);
    }
    if (event.actionId === 'unArchive') {
      this.unArchive(event.data['id']);
    }
  }

  onDtInit(dtHandler: DatatableHandler): void {
    this.dtHandler = dtHandler;
    this.dtHandler.create();
  }

  private passwordChange(id: string): void {
    this._modalService
      .addModal(ConfirmModalComponent, {
        title: 'Jelszó módosítás',
        message: 'Biztosan szeretné a felhasználó általi jelszó változtatást kezdeményezni?\n' +
          'Ez esetben kiküldésre kerül a rögzített email címre egy üzenet, melyben egy jelszó cserére jogosító link lesz megtalálható.',
        confirmText: 'Igen',
        confirmClass: 'btn-primary text-white',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this.usersClient.requestNewPassword(id).subscribe(
            () => {
              this.dtHandler?.refresh();
              this._toastr.success('Sikeres jelszó változtató email küldés');
            },
            error => this.errorProcessorService.processError(error, true)
          );
        }
      });
  }

  private archive(id: string): void {
    this._modalService
      .addModal(ConfirmReasonModalComponent, {
        title: 'Felhasználó archiválása',
        message: 'Biztosan archiválni szeretné a kiválasztott felhasználót?',
        description: 'A folyamat hatására az adott felhasználó fiókja zárolva lesz!',
        confirmText: 'Igen',
        confirmClass: 'btn-danger text-white',
      })
      .subscribe(event => {
        if (event.result) {
          this.usersClient.archive(id, event.reason).subscribe(
            () => {
              this.dtHandler?.refresh();
              this._toastr.success('Sikeres archiválás');
            },
            error => this.errorProcessorService.processError(error, true)
          );
        }
      });
  }

  private unArchive(id: string): void {
    this._modalService
      .addModal(ConfirmReasonModalComponent, {
        title: 'Felhasználó aktiválása',
        message: 'Biztosan aktiválni szeretné a kiválasztott felhasználót?',
        confirmText: 'Igen',
        confirmClass: 'btn-primary text-white',
      })
      .subscribe(event => {
        if (event.result) {
          this.usersClient.unArchive(id, event.reason).subscribe(
            () => {
              this.dtHandler?.refresh();
              this._toastr.success('Sikeres aktiválás');
            },
            error => this.errorProcessorService.processError(error, true)
          );
        }
      });
  }
}
